import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, storeToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { QrCode, XCircle } from "lucide-react";

export default function StaffQrEntry() {
    const { token } = useParams();
    const nav = useNavigate();
    const { setUser } = useAuth();
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.post(`/auth/staff/qr/${encodeURIComponent(token)}`);
                storeToken(data.access_token);
                setUser(data.user);
                sessionStorage.setItem("staff_timeout_min", String(data.session_timeout_min || 3));
                toast.success("Accesso staff via QR");
                nav("/staff", { replace: true });
            } catch (err) {
                setError(err.response?.data?.detail || "QR non valido o revocato");
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]" data-testid="staff-qr-entry-page">
            <div className="max-w-sm text-center px-6">
                {error ? (
                    <>
                        <XCircle className="w-10 h-10 mx-auto text-[hsl(var(--destructive))]" strokeWidth={1} />
                        <h1 className="text-xl mt-4">{error}</h1>
                        <button onClick={() => nav("/staff/login")} className="co-btn-ghost mt-6">
                            Accedi con PIN
                        </button>
                    </>
                ) : (
                    <>
                        <QrCode className="w-10 h-10 mx-auto text-[hsl(var(--primary))] animate-pulse" strokeWidth={1} />
                        <h1 className="text-xl mt-4">Autenticazione in corso…</h1>
                    </>
                )}
            </div>
        </div>
    );
}
